import { useState, useEffect } from 'react';
import { Users, UserPlus, Trash2 } from 'lucide-react';
import axios from 'axios';
import AdminLayout from './AdminLayout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const UsersAdmin = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('adminUser');
    if (stored) setCurrentUser(JSON.parse(stored));
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get(`${API}/admin/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(response.data);
    } catch (err) {
      console.error('Failed to fetch users', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div data-testid="users-admin-page">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-heading text-3xl font-bold text-slate-900 uppercase">Admin Users</h1>
            <p className="text-slate-500 mt-1">{users.length} registered admin{users.length !== 1 ? 's' : ''}</p>
          </div>
        </div>

        <div className="bg-white border-2 border-slate-100">
          <div className="p-4 border-b border-slate-100 bg-slate-50">
            <div className="grid grid-cols-4 gap-4 text-xs font-heading uppercase tracking-wider text-slate-500">
              <span>User</span>
              <span>Email</span>
              <span>Role</span>
              <span></span>
            </div>
          </div>
          
          {users.map((user) => (
            <div key={user.id} className="p-4 border-b border-slate-100 last:border-0 hover:bg-slate-50" data-testid={`user-item-${user.id}`}>
              <div className="grid grid-cols-4 gap-4 items-center">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                    {user.username.charAt(0).toUpperCase()}
                  </div>
                  <span className="font-medium text-slate-900">{user.username}</span>
                </div>
                <span className="text-slate-600">{user.email}</span>
                <span className="text-xs bg-slate-100 text-slate-600 px-2 py-1 w-fit uppercase">{user.role}</span>
                <div>
                  {user.id === currentUser?.id && (
                    <span className="text-xs text-orange-500">You</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 p-6 bg-slate-50 border-2 border-slate-100">
          <h3 className="font-heading text-lg font-bold text-slate-900 uppercase mb-2">Add New Admin</h3>
          <p className="text-slate-500 text-sm mb-4">
            To add a new admin user, they can register on the admin login page at <code className="bg-slate-200 px-2 py-0.5">/admin</code>
          </p>
          <a href="/admin" className="text-orange-500 text-sm hover:underline flex items-center gap-1">
            <UserPlus className="w-4 h-4" />
            Go to Admin Login
          </a>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UsersAdmin;
